var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.577,
    height: 17.96,
    viewBox: "0 0 17.577 17.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-outline",
    transform: "translate(0.788 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settings-outline-2",
    "data-name": "settings-outline",
    d: "M56.227,47.781a2.461,2.461,0,1,0,2.208,2.208A2.461,2.461,0,0,0,56.227,47.781Zm5.926,2.449a5.934,5.934,0,0,1-.059.8l1.739,1.364a.416.416,0,0,1,.094.529l-1.645,2.846a.416.416,0,0,1-.505.177l-1.727-.7a.62.62,0,0,0-.583.067,6.325,6.325,0,0,1-.828.482.613.613,0,0,0-.339.467l-.259,1.842a.426.426,0,0,1-.411.353H54.34a.427.427,0,0,1-.411-.341l-.258-1.839a.618.618,0,0,0-.346-.47,5.972,5.972,0,0,1-.825-.483.615.615,0,0,0-.581-.066l-1.726.695a.416.416,0,0,1-.505-.176l-1.645-2.846a.415.415,0,0,1,.094-.529l1.47-1.154a.617.617,0,0,0,.231-.542c-.014-.16-.022-.32-.022-.481s.008-.318.022-.475a.615.615,0,0,0-.233-.536l-1.469-1.154a.416.416,0,0,1-.091-.526l1.645-2.846a.416.416,0,0,1,.505-.177l1.727.7a.62.62,0,0,0,.583-.067,6.326,6.326,0,0,1,.828-.482.613.613,0,0,0,.339-.467l.259-1.842A.426.426,0,0,1,54.34,42h3.29a.427.427,0,0,1,.411.341L58.3,44.18a.618.618,0,0,0,.346.47,5.973,5.973,0,0,1,.825.483.615.615,0,0,0,.581.066l1.726-.695a.416.416,0,0,1,.505.176l1.645,2.846a.415.415,0,0,1-.094.529l-1.47,1.154a.617.617,0,0,0-.233.542C62.145,49.91,62.154,50.07,62.154,50.23Z",
    transform: "translate(-47.985 -42)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBlueIcon);
export default __webpack_public_path__ + "static/media/settings-blue-icon.ad82af22a5a21a175aa8c1f3756ade31.svg";
export { ForwardRef as ReactComponent };